import get from "lodash/get";
import { createSelector } from "reselect";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
export const getIsExpanded = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].isExpanded`), (isExpanded) => Boolean(isExpanded));
